enum CategorySize  {
    Large = 1,
    Medium = 2
}

export default CategorySize